import { Flex, IPropsInterface, Loader, Span } from '@fareye/ui'
import {
  cancelToken,
  FaBolt,
  FaDotCircle,
  FaFlag,
  get,
  toIST,
  hhmmAdoMMMNoIST,
  isEmpty,
  poiTypeIcon,
  startCase
} from '@fareye/utils'
import React from 'react'
import { useInView } from 'react-intersection-observer'
import { TimeLine, TimeLineContent } from '../../../style/styled'
import FieldValue from '../components/FieldValue'
import { default as Stages } from '../components/Stage'

export interface ITimeLineLine extends IPropsInterface {
  borderColor: 'blue7' | 'gray7'
  borderStyle: 'solid' | 'dotted'
}

export const MultiModelTimeLine = React.forwardRef(
  ({ timelineData, etaInfo, baseUrl, id }: any, refs?: any) => {
    const [etaData, setEtaData] = React.useState(() => etaInfo)
    const [loading, setLoading] = React.useState(() => !!etaInfo)

    const [ref, inView, entry] = useInView({
      /* Optional options */
      threshold: 0,
      triggerOnce: true
    })
    const source = cancelToken().source()

    const originalData = timelineData

    const totalPoisAllowedOnTimeline = 2
    const timelineMinWidthPerStop =
      originalData.tripCompletionPerc / totalPoisAllowedOnTimeline
    const lastStopWidth = 100 - originalData.tripCompletionPerc
    async function fetchTimeline(slug: string) {
      try {
        setLoading(true)
        const {
          data: { content }
        } = await get(
          `${baseUrl}/api/v2/consigner_trips/eta_info?slug[]=${slug}`,
          source.token
        )
        const allPois = content[originalData.slug]
        const last2Pois = allPois.slice(
          allPois.length - totalPoisAllowedOnTimeline,
          allPois.length
        )
        setEtaData(last2Pois)
        setLoading(false)
      } catch (err:any) {
        setLoading(false)
        console.error('App Error:', err)
      }
    }

    React.useEffect(() => {
      if (inView) {
        !etaInfo && fetchTimeline(originalData.slug)
      } else {
        // source.cancel()
      }
      // return source.cancel()
    }, [inView])

    const stoppagesIns = originalData.stoppageInstances
    const overspeedingIns = originalData.overspeedingInstances
    let stoppages = originalData && originalData.stoppages
    let overspeeding = originalData && originalData.overspeeding

    const iconSize = 20
    const endIconSize = iconSize + 5
    const iconStyle: React.CSSProperties = {
      border: '1px solid grey',
      padding: 5,
      margin: '10px 0 5px',
      borderRadius: '50%',
      background: '#fff'
    }
    const EndStageNameStyles = {
      fontWeight: 700,
      fontSize: 14,
      marginBottom: -5
    }
    const hasEtaPOIs = etaData && etaData.length > 0
    const stoppagesFiltered =
      !isEmpty(stoppages[`-${hasEtaPOIs && etaData[0].poi_reached_id}`]) &&
      stoppages[`-${hasEtaPOIs && etaData[0].poi_reached_id}`].filter(
        (item: any) => item.duration
      )
    const stoppagesBetweenOD = stoppagesIns.filter((item: any) => item.duration)
    const showTimeline =
      hasEtaPOIs || !isEmpty(stoppagesIns) || !isEmpty(overspeedingIns)
    if (!showTimeline) {
      // return <div ref={ref} />
    }
    return (
      <TimeLine id={originalData.slug} ref={ref}>
        {loading ? (
          <div style={{ padding: '45px', width: '100%', textAlign: 'center' }}>
            <Loader height="20px" width="20px" variant="spin" />
          </div>
        ) : (
          <>
            {/* <NavigatorPrev>
              <FaCaretLeft size={iconSize} />
            </NavigatorPrev> */}
            <Flex column alignItemsFlexEnd style={{ width: 135 }}>
              <Span
                variant="ellipsis"
                style={{ ...EndStageNameStyles, textAlign: 'right' }}
              >
                {originalData.origin}
              </Span>
              <FaBolt style={iconStyle} size={endIconSize} />
              <FieldValue
                style={{ marginTop: 2, width: '100%' }}
                label="In:"
                value={
                  originalData.loadingInTime
                    ? hhmmAdoMMMNoIST(originalData.loadingInTime)
                    : '-'
                }
              />
              <FieldValue
                style={{ marginBottom: 0, width: '100%' }}
                label="Out:"
                value={
                  originalData.loadingOutTime
                    ? hhmmAdoMMMNoIST(originalData.loadingOutTime)
                    : '-'
                }
              />
            </Flex>
            <TimeLineContent>
              <Stages
                style={{
                  stage: {
                    width: hasEtaPOIs ? `${timelineMinWidthPerStop}%` : '100%'
                  },
                  iconLine: { height: endIconSize }
                }}
                line={{
                  color: hasEtaPOIs ? 'blue7' : 'gray5',
                  style: hasEtaPOIs ? 'solid' : 'dotted',
                  width:
                    etaData && etaData.length > 0
                      ? null
                      : originalData.tripCompletionPerc
                }}
                stoppages={
                  (hasEtaPOIs ? stoppagesFiltered : stoppagesBetweenOD) || []
                }
                overspeeding={
                  hasEtaPOIs
                    ? !isEmpty(
                        overspeeding[
                          `-${hasEtaPOIs && etaData[0].poi_reached_id}`
                        ]
                      )
                    : overspeedingIns.length
                }
              />
              {etaData &&
                etaData.map((item: any, i: number) => {
                  const isLastIteration = i == etaData.length - 1
                  const poiId =
                    !isLastIteration &&
                    `${item.poi_reached_id}-${etaData[i + 1].poi_reached_id}`
                  const hasStoppages = (poiId && stoppages[poiId]) || []
                  const hasOverspeeding =
                    poiId && overspeeding[poiId] && overspeeding[poiId].length
                  const Icon = poiTypeIcon[item.poi_type]
                  return (
                    <Stages
                      key={i}
                      style={{
                        stage: {
                          width: `${
                            isLastIteration
                              ? lastStopWidth
                              : timelineMinWidthPerStop
                          }%`
                        }
                      }}
                      name={startCase(item.poi_name)}
                      eta={`${hhmmAdoMMMNoIST(
                        toIST(item.predicted_eta_from_here)
                      )}`}
                      tripRunningStatus={''}
                      poiType={item.poi_type}
                      icon={
                        isLastIteration &&
                        !originalData.ata &&
                        originalData.tripCompletionPerc != 100 ? (
                          <FaDotCircle
                            color="#9776fc"
                            size={iconSize}
                            style={{
                              width: 12,
                              backgroundColor: '#fff',
                              padding: '4px 0',
                              marginLeft: '-4px'
                            }}
                          />
                        ) : (
                          <Icon
                            title={startCase(item.poi_type)}
                            size={iconSize}
                            style={{ padding: '4px 0', marginLeft: '-4px' }}
                          />
                        )
                      }
                      line={{
                        color: `${
                          !originalData.ata && isLastIteration
                            ? 'gray7'
                            : 'blue7'
                        }`,
                        style: `${
                          !originalData.ata && isLastIteration
                            ? 'dotted'
                            : 'solid'
                        }`,
                        width:
                          originalData.tripCompletionPerc == 100 ? 100 : null
                      }}
                      stoppages={!isLastIteration && hasStoppages}
                      overspeeding={!isLastIteration && hasOverspeeding}
                      enterDatetime={hhmmAdoMMMNoIST(item.poi_enter_time)}
                      exitDatetime={hhmmAdoMMMNoIST(item.poi_exit_time)}
                    />
                  )
                })}
              <Stages
                style={{ stage: { width: 0, minWidth: 0, flexGrow: 0 } }}
              />
            </TimeLineContent>
            <Flex column style={{ width: 140 }} alignItemsFlexStart>
              <Span variant="ellipsis" style={EndStageNameStyles}>
                {originalData.consigneeName}
              </Span>
              <FaFlag style={iconStyle} size={endIconSize} />
              <Flex column alignItemsCenter>
                <FieldValue
                  style={{ marginBottom: 0, width: '100%' }}
                  label={originalData.ata ? null : 'ETA:'}
                  value={
                    originalData.ata
                      ? null
                      : hhmmAdoMMMNoIST(originalData.rt_eta || originalData.eta)
                  }
                />
                <FieldValue
                  style={{ marginTop: 2, width: '100%' }}
                  label={originalData.ata ? 'ATA:' : 'STA:'}
                  value={hhmmAdoMMMNoIST(originalData.ata || originalData.eta)}
                />
              </Flex>
            </Flex>
            {/* <NavigatorNext>
              <FaCaretRight size={iconSize} />
            </NavigatorNext> */}
          </>
        )}
      </TimeLine>
    )
  }
)
